var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-danger btn-xs",attrs:{"disabled":_vm.loading},domProps:{"innerHTML":_vm._s(_vm.btnLabel)},on:{"click":_vm.confirmDeleteCarrierTax}})}
var staticRenderFns = []

export { render, staticRenderFns }